import { on } from 'delegated-events';
import invisibleFocus from '../../../javascripts/utils/invisibleFocus';

on('click', 'summary.accordion__summary', (event) => {
  const { currentTarget: $summary } = event;
  invisibleFocus($summary);
});
